import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";

const columns = [
  {
    heading: "Parlay Assistant",
    links: [
      { label: "About", to: "/about", type: "route", testId: FOOTER.linkAbout },
      { label: "Playbook", to: "/playbook", type: "route", testId: FOOTER.linkPlaybook },
      { label: "Sponsors", to: "/sponsors", type: "route", testId: FOOTER.linkSponsors },
      {
        label: "Contact",
        href: "mailto:advertise@parlayassistant.com",
        type: "anchor",
        testId: FOOTER.linkContact,
      },
    ],
  },
  {
    heading: "Legal",
    links: [
      {
        label: "Privacy Policy",
        to: "/privacy",
        type: "route",
        testId: FOOTER.linkPrivacy,
      },
      { label: "Terms of Use", to: "/terms", type: "route", testId: FOOTER.linkTerms },
    ],
  },
  {
    heading: "Play Safe",
    links: [
      {
        label: "Responsible Gambling",
        href: "#responsible-gambling",
        type: "anchor",
        testId: FOOTER.linkResponsible,
      },
      {
        label: "1-800-GAMBLER",
        href: "tel:18004262537",
        type: "anchor",
      },
    ],
  },
];

export const Footer = () => {
  return (
    <footer
      id="site-footer"
      data-testid={FOOTER.root}
      className="mt-16 md:mt-24 border-t border-slate-800/80"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-12">
        <div
          id="responsible-gambling"
          className="pa-card-dark p-6 md:p-7 flex flex-col md:flex-row gap-4 md:items-start"
        >
          <div
            aria-hidden="true"
            className="shrink-0 w-11 h-11 rounded-xl inline-flex items-center justify-center"
            style={{
              background: "rgba(245,158,11,0.14)",
              color: "#fbbf24",
              border: "1px solid rgba(245,158,11,0.3)",
            }}
          >
            <ShieldAlert size={20} />
          </div>
          <div>
            <h2 className="font-display text-white text-lg uppercase tracking-wide">
              Responsible Gambling
            </h2>
            <p className="mt-1.5 text-slate-300 text-sm leading-relaxed">
              Parlay Assistant provides calculation and educational tools only. It does not
              accept wagers, provide guaranteed betting results, or operate as a sportsbook.
              Calculator results are estimates and may differ from sportsbook payouts because
              of rounding, rules, limits, voided selections, or correlated-leg restrictions.
              You must meet the legal gambling age in your jurisdiction. Please gamble
              responsibly.
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <p className="font-display text-white text-lg uppercase tracking-wide">
              Parlay Assistant
            </p>
            <p className="mt-2 text-slate-400 text-sm">
              Free tools for calculating parlay payouts and converting betting odds.
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.heading}>
              <p className="font-display text-slate-200 text-sm uppercase tracking-wider">
                {col.heading}
              </p>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) =>
                  l.type === "route" ? (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        data-testid={l.testId}
                        className="text-slate-400 hover:text-white text-sm transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ) : (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        data-testid={l.testId}
                        className="text-slate-400 hover:text-white text-sm transition-colors"
                      >
                        {l.label}
                      </a>
                    </li>
                  ),
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-slate-500">
          <p>© 2026 Parlay Assistant. All rights reserved.</p>
          <p>Educational tool · Not a sportsbook · 21+</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
